import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from "@reach/router";
import {
  Lock,
  Dashboard,
  EventAvailable,
  ViewList, 
  Work,
  Person,
  CalendarTodayTwoTone,
  Mail
} from '@material-ui/icons';

function ListItemLink(props) {
  const { icon, primary, to, selected, setActiveLoc } = props;
  const CustomLink = React.useMemo(
    () =>
      React.forwardRef((linkProps, ref) => (
        <Link ref={ref} to={to} {...linkProps} onClick={()=>setActiveLoc(to)}
        />
      )),
    [to, setActiveLoc],
  );

  return (
    <li>
      <ListItem button component={CustomLink} selected={selected}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={primary} />
      </ListItem>
    </li>
  );
}

export const MainListItems = (props) =>{
  const [activeLoc, setActiveLoc] = React.useState(window.location.pathname);
  return (
  <div>

    <ListItemLink to="/" primary="Dashboard" icon={<Dashboard />} 
    selected={ activeLoc ==='/' ? true:false} setActiveLoc={setActiveLoc}
    />

    <ListItemLink to="/messaging" primary="Messaging" icon={<Mail />} 
    selected={ activeLoc ==='/messaging' ? true:false} setActiveLoc={setActiveLoc}
    />

    <ListItemLink to="/calendar" primary="School Calendar" icon={<CalendarTodayTwoTone />} 
    selected={ activeLoc ==='/calendar' ? true:false} setActiveLoc={setActiveLoc}
    />

    <ListItemLink to="/schedule" primary="My Schedule" icon={<EventAvailable />} 
    selected={ activeLoc ==='/schedule' ? true:false} setActiveLoc={setActiveLoc}
    />

    <ListItemLink to="/sections" primary="My Sections" icon={<ViewList />} 
    selected={ activeLoc ==='/sections' ? true:false} setActiveLoc={setActiveLoc}
    />

    {/* <ListItemLink to="/manage/sections" primary="Manage Sections" icon={<Work />} 
    selected={ activeLoc ==='/manage/sections' ? true:false} setActiveLoc={setActiveLoc}
    /> */}

    <ListItemLink to="/subjects" primary="My Subjects" icon={<Work />} 
    selected={ activeLoc ==='/subjects' ? true:false} setActiveLoc={setActiveLoc}
    />

    <ListItemLink to="/profile" primary="Profile" icon={<Person />} 
    selected={ activeLoc ==='/profile' ? true:false} setActiveLoc={setActiveLoc}
    />

    <ListItem button
    onClick={()=>props.updateUserInformation({})}>
      <ListItemIcon>
        <Lock />
      </ListItemIcon>
      <ListItemText primary="Logout" />
    </ListItem>

  </div>
);
}